export enum DisplayMode {
  SELECTED = 'selected',
  DESELECTED = 'deselected',
  ERROR = 'error',
  MODIFIED = 'modified',
  MODIFIED_BY_CHOOSE = 'modified_by_choose',
}
